"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GenericHeroContent = _interopRequireDefault(require("./GenericHeroContent"));

var _classnames = _interopRequireDefault(require("classnames"));

var _common = require("@insided/shared/utils/common");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var HeroBackgroundImage = function HeroBackgroundImage(_ref) {
  var heroImage = _ref.heroImage,
      imageDescription = _ref.imageDescription;
  return (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(heroImage),
    alt: imageDescription !== null && imageDescription !== void 0 ? imageDescription : '',
    className: "hero-background-image"
  });
};

var GenericHeroContainer = function GenericHeroContainer(_ref2) {
  var centered = _ref2.centered,
      heroImage = _ref2.heroImage,
      imageDescription = _ref2.imageDescription,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      isFederatedSalesforceSearch = _ref2.isFederatedSalesforceSearch,
      isFederatedSkilljarSearch = _ref2.isFederatedSkilljarSearch,
      isFederatedFreshdeskSearch = _ref2.isFederatedFreshdeskSearch,
      titleColor = _ref2.titleColor,
      titleColorDisplay = _ref2.titleColorDisplay,
      subtitleColor = _ref2.subtitleColor,
      subtitleColorDisplay = _ref2.subtitleColorDisplay,
      searchRevamp = _ref2.searchRevamp,
      aiSearchSummary = _ref2.aiSearchSummary,
      isGuest = _ref2.isGuest,
      aiSmartSearchEnableForAllRoles = _ref2.aiSmartSearchEnableForAllRoles,
      liveSearchSuggestedQuestions = _ref2.liveSearchSuggestedQuestions,
      categories = _ref2.categories,
      productAreas = _ref2.productAreas;

  var isImagePerformanceEnabled = _common.common.isModuleActive('widgetImagePerformance');

  var backgroundImageStyle = heroImage && !isImagePerformanceEnabled ? {
    backgroundImage: "url(".concat(heroImage, ")")
  } : {};
  var imageAccessibilityProps = !isImagePerformanceEnabled ? _objectSpread({
    role: imageDescription !== '' ? 'img' : 'presentation'
  }, imageDescription !== '' && {
    'aria-label': imageDescription
  }) : {};

  var renderHeroContent = function renderHeroContent() {
    return (0, _preact.h)(_GenericHeroContent.default, {
      title: title,
      subtitle: subtitle,
      titleColor: titleColor,
      titleColorDisplay: titleColorDisplay,
      subtitleColor: subtitleColor,
      subtitleColorDisplay: subtitleColorDisplay,
      isFederatedSalesforceSearch: isFederatedSalesforceSearch,
      isFederatedSkilljarSearch: isFederatedSkilljarSearch,
      isFederatedFreshdeskSearch: isFederatedFreshdeskSearch,
      searchRevamp: searchRevamp,
      aiSearchSummary: aiSearchSummary,
      isGuest: isGuest,
      aiSmartSearchEnableForAllRoles: aiSmartSearchEnableForAllRoles,
      liveSearchSuggestedQuestions: liveSearchSuggestedQuestions,
      categories: categories,
      productAreas: productAreas,
      centered: centered
    });
  };

  if (centered) {
    return (0, _preact.h)("div", (0, _extends2.default)({
      className: (0, _classnames.default)('brand-hero', 'qa-brand-hero', 'custom-hero-banner'),
      style: backgroundImageStyle
    }, imageAccessibilityProps), isImagePerformanceEnabled && heroImage && (0, _preact.h)(HeroBackgroundImage, {
      heroImage: heroImage,
      imageDescription: imageDescription
    }), renderHeroContent());
  }

  return (0, _preact.h)("div", (0, _extends2.default)({
    className: "forum-featured-image",
    style: _objectSpread({
      backgroundColor: 'transparent'
    }, backgroundImageStyle)
  }, imageAccessibilityProps), isImagePerformanceEnabled && heroImage && (0, _preact.h)(HeroBackgroundImage, {
    heroImage: heroImage,
    imageDescription: imageDescription
  }), (0, _preact.h)("div", {
    className: "forum-featured-image__content brand-hero"
  }, (0, _preact.h)("div", {
    className: "sitewidth"
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('col', 'col--main', 'has--side')
  }, renderHeroContent()))));
};

var _default = GenericHeroContainer;
exports.default = _default;